import { LinearProgressProps } from "@mui/material";

import {
  MIN_PROGRESS_VALUE,
  PERCENTAGE_MULTIPLIER,
} from "../generic-upload.constants";
import { IGenericUploadProcessStatistics } from "../generic-upload.models";

export const calculateProgressPercentage = (
  processed: number,
  total: number,
): number => {
  if (total <= MIN_PROGRESS_VALUE) {
    return MIN_PROGRESS_VALUE;
  }

  return Math.round((processed / total) * PERCENTAGE_MULTIPLIER);
};

export const getProcessedCount = (
  statistics: IGenericUploadProcessStatistics,
): number => {
  return (
    statistics.successfullyCreated +
    statistics.successfullyUpdated +
    statistics.failed
  );
};

export const resolveProgressTitle = (
  isProcessing: boolean,
  hasErrors: boolean,
  t: (key: string) => string,
): string => {
  if (isProcessing) {
    return t("genericUpload.processing");
  }

  if (hasErrors) {
    return t("genericUpload.completedWithErrors");
  }

  return t("genericUpload.completedSuccessfully");
};

export const resolveProgressColor = (
  isProcessing: boolean,
  hasErrors: boolean,
): LinearProgressProps["color"] => {
  if (isProcessing) {
    return "primary";
  }

  if (hasErrors) {
    return "error";
  }

  return "success";
};
